/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespCollectionsModules_itemSearch = {
    readonly collectionsModules: ReadonlyArray<{
        readonly moduleType: string | null;
        readonly id: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SbSharedCollectionsModulesHeroModule_collectionsModules" | "SharedProductCarousel_collectionsModules" | "SbRespCollectionsComponents_collectionsModules" | "SbRespCreatorSpotlightModule_collectionsModules">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsComponents_itemSearch">;
    readonly " $refType": "SbRespCollectionsModules_itemSearch";
};
export type SbRespCollectionsModules_itemSearch$data = SbRespCollectionsModules_itemSearch;
export type SbRespCollectionsModules_itemSearch$key = {
    readonly " $data"?: SbRespCollectionsModules_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespCollectionsModules_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "collectionsModules",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "previewId",
          "variableName": "contentModuleId"
        }
      ],
      "concreteType": null,
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "id",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedCollectionsModulesHeroModule_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SharedProductCarousel_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespCollectionsComponents_collectionsModules",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespCreatorSpotlightModule_collectionsModules",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '15c83ab53da2f2504b701d2d225412ce';
export default node;
